import React from 'react';

import Tooltip from 'component/Layout/Tooltip';

import { useTranslation } from 'hooks/useTranslation';

import { ReactComponent as IconChatty } from 'media/svg/chattyLogo.svg';
import { ReactComponent as IconInfoCircle } from 'media/svg/infoCircle.svg';

import styles from '../AiSmartFilter.module.scss';

const Header: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.Header}>
            <span className={styles.HeaderIcon}>
                <IconChatty className={styles.IconChatty} />
            </span>
            <h3 className={styles.HeaderTitle}>
                {t('TRANS-intelligent-filter')}
                <Tooltip
                    align={{ offset: [16, 0] }}
                    content={
                        <span>
                            <b>{t('TRANS-intelligent-filter')}</b>
                            <p>{t('TRANS-intelligent-filter-uses-ai-tech')}</p>
                        </span>
                    }
                >
                    <span className={styles.IconWrapper}>
                        <IconInfoCircle className={styles.IconInfo} />
                    </span>
                </Tooltip>
            </h3>
        </div>
    );
};

export default Header;
